/* IDIKO — Header:
   - Transparente sobre el hero (solo en páginas con banner-hero)
   - Al salir del hero: fondo crema sólido
   - Hide al bajar scroll, reaparece al subir
*/
(function(){
  const group = document.getElementById('header-group');
  if (!group) return;

  /* Solo activar modo hero en la home (path "/") */
  const isHome = window.location.pathname === '/' || window.location.pathname === '';
  const hero = isHome ? document.querySelector('.banner-hero') : null;

  /* Marcar el body si NO hay hero (= no es home), para que el CSS pueda compensar la altura del header fijo */
  if (hero) {
    document.body.classList.remove('idk-no-hero');
  } else {
    document.body.classList.add('idk-no-hero');
  }
  const updateHeaderOffset = () => {
    const h = group.offsetHeight || 106;
    document.documentElement.style.setProperty('--idk-header-offset', h + 'px');
  };
  updateHeaderOffset();
  window.addEventListener('resize', updateHeaderOffset, { passive: true });

  const logoImg = group.querySelector('.header-logo__image, .header-logo img');
  const originalLogoSrc = logoImg ? (logoImg.currentSrc || logoImg.src) : null;
  const whiteLogoUrl = 'https://cdn.shopify.com/s/files/1/1009/4837/7943/files/logotipo_IDIKO_page-0001-03.png?v=1778074915';

  function setLogo(useWhite){
    if (!logoImg || !whiteLogoUrl || !originalLogoSrc) return;
    const target = useWhite ? whiteLogoUrl : originalLogoSrc;
    if (logoImg.src !== target) {
      logoImg.src = target;
      logoImg.removeAttribute('srcset');
    }
  }

  let last = window.scrollY;
  let ticking = false;

  const getHeroBottom = () => hero ? (hero.getBoundingClientRect().bottom + window.scrollY - 80) : 0;

  function apply(){
    const y = window.scrollY;

    if (hero) {
      const threshold = getHeroBottom() - 120;
      if (y < threshold) {
        group.setAttribute('data-transparent', '');
        group.removeAttribute('data-scrolled');
        setLogo(true);
      } else {
        group.removeAttribute('data-transparent');
        group.setAttribute('data-scrolled', '');
        setLogo(false);
      }
    } else {
      /* Sin hero: siempre sólido */
      group.removeAttribute('data-transparent');
      group.setAttribute('data-scrolled', '');
    }

    /* Hide on scroll down / show on scroll up */
    const scrollThreshold = 80;
    if (y < scrollThreshold) {
      group.removeAttribute('data-hidden');
    } else if (y > last + 6) {
      group.setAttribute('data-hidden', 'true');
      /* Cerrar cualquier dropdown abierto al ocultar */
      group.querySelectorAll('details[open]').forEach(d => d.removeAttribute('open'));
    } else if (y < last - 6) {
      group.removeAttribute('data-hidden');
    }

    last = y;
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(apply); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', apply, { passive: true });
  window.addEventListener('load', apply);
  if (document.readyState === 'complete') apply();
  else document.addEventListener('DOMContentLoaded', apply);
  setTimeout(apply, 300);
  setTimeout(apply, 1200);
})();
